import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
/**
 *
 * @param {string} icon Name of the icon
 * @param {string} extraClass Extra class names as a string, no leading/trailing spaces needed.
 * @param {string } color see which colors that are available in icons.scss
 * @returns {JSX.Element}
 * @constructor
 */
export const Svg = ({ icon, extraClass = '', color = '' }) => {
    let elClass = `icon icon-${icon} ${extraClass}`.trim();
    if (color.length) {
        elClass += ` icon--${color}`;
    }
    return (_jsx("svg", { className: elClass, "aria-hidden": "true", focusable: "false", children: _jsx("use", { xlinkHref: `#${icon}` }) }));
};
